import Form from './Form/Form';

export { default as Form, generateForm } from './Form';
export { default as Templates, generateTemplates } from './Templates';
export { default as Theme, generateTheme } from './Theme';
export { default as Widgets, generateWidgets } from './Widgets';

export default Form;
